/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_DateInputs */

const en_settings_billing_date = /** @type {(inputs: Settings_Billing_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const zh_settings_billing_date = /** @type {(inputs: Settings_Billing_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日期`)
};

/**
* | output |
* | --- |
* | "Date" |
*
* @param {Settings_Billing_DateInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_date = /** @type {((inputs?: Settings_Billing_DateInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_DateInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_date(inputs)
	return zh_settings_billing_date(inputs)
});
export { settings_billing_date as "settings.billing.date" }